// utils/formatters.ts
export const formatPhoneNumber = (phone: string | undefined | null): string => {
  // Если phone undefined, null или пустая строка
  if (!phone) return 'Пользователь'
  
  // Убираем все нецифровые символы
  const cleaned = phone.replace(/\D/g, '')
  
  // Если после очистки пусто
  if (!cleaned) return 'Пользователь'
  
  // Если номер российский и имеет 11 цифр (7XXXXXXXXXX или 8XXXXXXXXXX)
  if (cleaned.length === 11 && (cleaned.startsWith('7') || cleaned.startsWith('8'))) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9)}`
  }
  
  // Если номер уже с +7 и имеет 12 цифр (+7XXXXXXXXXX)
  if (cleaned.length === 12 && cleaned.startsWith('7')) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9)}`
  }
  
  // Если номер короткий (например, 9940822881 без первой 7)
  if (cleaned.length === 10) {
    return `+7 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 8)}-${cleaned.slice(8)}`
  }
  
  // Для других форматов возвращаем исходное значение или обрезаем
  return phone.length > 15 ? phone.slice(0, 15) + '...' : phone
}